import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { SiteData } from '../types/data';

interface ContactProps {
  data: SiteData['contact'];
}

export const Contact = ({ data }: ContactProps) => {
  return (
    <section id="kontakt" className="py-20 bg-slate-900 text-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">{data.title}</h2>
            <p className="text-gray-400 mb-10 text-lg">
              {data.description}
            </p>
            
            <div className="space-y-8">
              <div className="flex items-start gap-4">
                <div className="bg-primary/20 p-3 rounded-lg">
                  <Phone className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-1">{data.phoneTitle}</h3>
                  <div className="flex flex-col gap-1">
                    {data.phoneValues.map((phone, index) => (
                      <a key={index} href={`tel:${phone.replace(/\s/g, '')}`} className="text-2xl text-primary font-bold hover:text-primary-hover transition-colors">
                        {phone}
                      </a>
                    ))}
                  </div>
                  <p className="text-gray-400 mt-1">{data.phoneNote}</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="bg-primary/20 p-3 rounded-lg">
                  <Mail className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-1">{data.emailTitle}</h3>
                  <a href={`mailto:${data.emailValue}`} className="text-lg text-gray-300 hover:text-white transition-colors">
                    {data.emailValue}
                  </a>
                  <p className="text-gray-400 mt-1">{data.emailNote}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-primary/20 p-3 rounded-lg">
                  <MapPin className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-1">{data.addressTitle}</h3>
                  <p className="text-lg text-gray-300">
                    {data.addressValue}
                  </p>
                  <p className="text-gray-400 mt-1">{data.addressNote}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl overflow-hidden shadow-xl h-[400px] lg:h-auto">
            <iframe 
              src={data.mapUrl}
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title={data.mapTitle}
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};
